import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { AddressStore } from '../../../stores/AddressStore';
import { AddressCard } from '../../../common/address-card';
import styles from './AddressList.css';
import { BUTTON_TYPES } from '../../../common/address-card/AddressCard';
import { Spinner } from '../../../common/spinner';

const IPropTypes = {
  className: PropTypes.string,
  onSelection: PropTypes.func,
};

const defaultProps = {
  className: '',
  onSelection: () => {},
};

const AddressList = props => (
  <div className={props.className}>
    <h2 className={styles.title}>
      Mis Direcciones
    </h2>
    { AddressStore.loadingAddresses &&
      <Spinner className={styles.addressListSpinner} />
    }
    {
      !AddressStore.loadingAddresses &&
      !!AddressStore.addresses &&
      !AddressStore.addresses.length &&
      <p className={styles.message}>
        No tienes direcciones creadas, por favor crea una antes de continuar.
      </p>
    }
    {
      !AddressStore.loadingAddresses &&
      !!AddressStore.addresses &&
      !!AddressStore.addresses.length &&
      <div className={styles.addressContainer}>
        {
          AddressStore.addresses.map(address => (
            <AddressCard
              address={address}
              className={styles.addressCard}
              key={address.id}
              buttonType={BUTTON_TYPES.SELECT}
              onButtonClick={props.onSelection}
            />
          ))
        }
      </div>
    }
  </div>
);

AddressList.propTypes = IPropTypes;
AddressList.defaultProps = defaultProps;

const ObservedAddressList = observer(AddressList);

export { ObservedAddressList as AddressList };



// WEBPACK FOOTER //
// ./src/pages/choose-address/address-list/AddressList.jsx